module.exports = __webpack_public_path__ + "img/unfilled-riceball.7c4d8549.svg";